module.exports = __webpack_public_path__ + "img/senalando-izqve.73f4e702.png";